export const testimonials = [
    {
        author: 'Tracy T',
        location: 'Inglewood, CA',
        quote: 'Hugo allowed me to pay for car insurance without going into debt.',
        avatar: 'tracy',
    },
    {
        author: 'Roberto P',
        location: 'Maywood, CA',
        quote: 'Hugo helped me insure a car that I rarely used and saved me money in the process.',
        avatar: 'roberto',
    },
    {
        author: 'Amber Y',
        location: 'Moreno Valley, CA',
        quote: 'Using Hugo was a great experience. Very convenient and easy to use. Perfect for driver’s on a budget!',
        avatar: 'amber',
    },
    {
        author: 'Abbie H',
        location: 'Elk Grove, CA',
        quote: 'Paying for insurance by the day finally made insurance affordable.',
        avatar: 'abbie',
    },
    {
        author: 'Danielle S',
        location: 'Palmdale, CA',
        quote: 'Since I’m pregnant and a stay at home mom, saving money is a priority for emergencies.',
        avatar: 'danielle',
    },
    {
        author: 'Brandy M',
        location: 'Stockton, CA',
        quote: 'Hugo wasn’t as intimidating as more known insurance companies.',
        avatar: 'brandy',
    },
];
